import httpClient from "@/services/base.service.js";

let apiBase = '/api/v1/bidinvitationselectiontype';

export default {
  getAll: function () {
    return httpClient.get(`${apiBase}/get`);
  }
};
